import { defineMessages } from 'react-intl';

export default defineMessages({
  editTitle: {
    id: 'classesStudents.editClassModal.editTitle',
    defaultMessage: 'EDIT STUDENT',
  },
  addTitle: {
    id: 'classesStudents.editClassModal.addTitle',
    defaultMessage: 'ADD STUDENT',
  },
  viewTitle: {
    id: 'classesStudents.editClassModal.viewTitle',
    defaultMessage: 'VIEW STUDENT',
  },
  message: {
    id: 'classesStudents.editClassModal.message',
    defaultMessage: 'Type the student name and surname',
  },
  back: {
    id: 'classesStudents.editClassModal.back',
    defaultMessage: 'Back',
  },
  continue: {
    id: 'classesStudents.editClassModal.continue',
    defaultMessage: 'Continue',
  },
  name: {
    id: 'classesStudents.editClassModal.name',
    defaultMessage: 'Name',
  },
  lastname: {
    id: 'classesStudents.editClassModal.lastname',
    defaultMessage: 'Surname',
  },
  registration: {
    id: 'classesStudents.editClassModal.registration',
    defaultMessage: 'Registration',
  },
  call: {
    id: 'classesStudents.editClassModal.call',
    defaultMessage: 'Call',
  },
  email: {
    id: 'classesStudents.editClassModal.email',
    defaultMessage: 'Email',
  },
  course: {
    id: 'classesStudents.editClassModal.course',
    defaultMessage: 'Course',
  },
  error_schoolNotFound: {
    id: 'classesStudents.editClassModal.error_schoolNotFound',
    defaultMessage: 'This school does not exist',
  },
  error_courseNotFound: {
    id: 'classesStudents.editClassModal.error_courseNotFound',
    defaultMessage: 'This course does not exist',
  },
  error_addPermissionDenied: {
    id: 'classesStudents.editClassModal.error_addPermissionDenied',
    defaultMessage: 'User does not have permission to add groups',
  },
  error_editPermissionDenied: {
    id: 'classesStudents.editClassModal.error_editPermissionDenied',
    defaultMessage: 'User does not have permission to edit groups',
  },
  error_registrationAlreadyExists: {
    id: 'classesStudents.editClassModal.error_registrationAlreadyExists',
    defaultMessage: 'Registration already exists',
  },
  error_studentAlreadyRegisteredWithThisRegistration: {
    id: 'classesStudents.editClassModal.error_studentAlreadyRegisteredWithThisRegistration',
    defaultMessage: 'This student is already registered with this registration number',
  },
  error_studentAlreadyRegisteredInThisCourseWithThisEmail: {
    id: 'classesStudents.editClassModal.error_studentAlreadyRegisteredInThisCourseWithThisEmail',
    defaultMessage: 'This student is already registered in this course with this email',
  },
  error_studentAlreadyExists: {
    id: 'classesStudents.editClassModal.error_studentAlreadyExists',
    defaultMessage: 'Student already exists',
  },
  error_emailAlreadyExists: {
    id: 'classesStudents.editClassModal.error_emailAlreadyExists',
    defaultMessage: 'Sorry, there is already another user with the email you entered',
  },
  error_generic: {
    id: 'classesStudents.editClassModal.error_generic',
    defaultMessage: 'Server error',
  },
});
